module.exports = __webpack_public_path__ + "static/media/hardware.fda075e9.jpg";